import React, {PureComponent as Component} from 'react';
import {MCbrowser} from "../../../Context/browserContext";
import {ChevronLeft } from "react-feather";
import {Link} from "react-router-dom";
import GetOstanMemberDataTableApi from "./Api/GetDataTableApi";
import FollowingInsert2 from "./FollowingInsert2";

class    ShowFollowingBox  extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;
        this.listBox=[];
        this.HrefreshBox = this.refreshBox.bind(this);
        this.state = {loaded: false,isClose:false};
        this.props=props;
    }

    refreshBox(){
        this.getLoad();
    }

    componentDidMount() {
        this.getLoad();
        let page = this.context.page;
        page.dispatcher.add("route", "following","inserted",this.HrefreshBox);
    }

    async getLoad() {
        let data = await GetOstanMemberDataTableApi();
        if (data === false) {
            this.setState({loaded: true,isClose:true});
        } else {
            this.listBox=[];
            let i=0;
            let s1;
            let c="";
            for (i=0;i<data.length;i++){
                s1='http://mdyaran.ir/membership/'+data[i].id+'/picture';
                if(i===data.length-1){
                    c="d-flex align-items-center osahan-post-header   people-list";
                }else{
                    c="d-flex align-items-center osahan-post-header mb-3 people-list";
                }
                let el= <div className={c}  key={data[i].id} >
                    <div className="dropdown-list-image mr-3">
                        <img   src="/images/avatar.jpg" data-src={s1} alt=""
                             className="lazyload blur-up img-fluid  rounded-circle mw150"/>
                        <div className="status-indicator bg-success" />
                    </div>
                    <div className="font-weight-bold ml-2">
                        <div className="text-truncate">
                            {data[i].username}
                        </div>
                        <div className="small text-gray-500">
                            {data[i].username}
                        </div>
                    </div>
                    <span className="mr-auto">
                       <FollowingInsert2 memberId={data[i].id}  />
                    </span>
                </div> ;
                 this.listBox.push(el);
            }
            this.setState({loaded: true});
        }
    }

    render() {
        return (
            <>
                <div className="box shadow-sm border rounded bg-white mb-3">
                    <div className="box-title border-bottom p-3 d-flex align-items-center">
                        <h6 className="m-0  ">
                            پیشنهادات استان
                        </h6>
                        <Link to="/membership/connection" className="mr-auto"  >
                            نمایش همه
                            <ChevronLeft size={16} />
                        </Link>
                    </div>
                    <div className="box-body p-3">
                        {this.listBox}
                    </div>
                </div>
            </>
        ); 
  }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

ShowFollowingBox.contextType = MCbrowser;

export default ShowFollowingBox;
